export const MONITORING_WALKTHROUGH_EVENT = {
  started: 'Monitoring Walkthrough Started',
  viewed: 'Monitoring Walkthrough Viewed',
  dismissed: 'Monitoring Walkthrough Dismissed',
  completed: 'Monitoring Walkthrough Completed',
} as const satisfies Record<string, string>;

export type MonitoringWalkthroughEventName =
  (typeof MONITORING_WALKTHROUGH_EVENT)[keyof typeof MONITORING_WALKTHROUGH_EVENT];

export type MonitoringWalkthroughSection = 'introPopup' | 'hintTour';

export type MonitoringWalkthroughEntryPoint = 'firstVisit' | 'introPopup';

export type MonitoringWalkthroughDismissMethod =
  | 'maybeLater'
  | 'escape'
  | 'clickOutside'
  | 'skip';

export type MonitoringWalkthroughCompletionType = 'hintsFinished';
